import React, { useEffect, useState } from 'react';
import './donorHeader.scss';
import { withTranslation } from 'react-i18next';
import { parseFloatByLanguage } from '../../../../../utils/functionCommon';

const DonorHeaderComponent = (props: any) => {
  const { donorDonations, dataDonation, t } = props;

  return (
    <div className="donor-header">
      <div className="donor-content-header">
        <div className="donor-content-description">
          <div className="content-text">
            <p className="headline-title headline">Hi {donorDonations?.donor_first_name || ''},</p>
            <p className="headline-title headline">{t('thank_you_description')}</p>
            <p className="headline-subtitle headline">
              {t('email_description_1')} {donorDonations?.donor_email || ''}
              {t('email_description_2')}
            </p>
          </div>
        </div>
      </div>
      <div className="donor-content-values">
        <div className="donor-value-container">
          <div className="donor-value row">
            <div className="spenden-container value-container col-md-4 col-12">
              <h3 className="value">{parseFloatByLanguage(dataDonation?.donations, t('language'))} </h3>
              <p className="sub-text">{t('donation')}</p>
            </div>
            <div className="area-container value-container col-md-4 col-12">
              <h3 className="value">{parseFloatByLanguage(dataDonation.areasDonation, t('language'))}</h3>
              <p className="sub-text">
                {t('protected')} m<sup>2</sup>
              </p>
            </div>
            <div className="co2-container value-container col-md-4 col-12">
              <h3 className="value">{parseFloatByLanguage(dataDonation?.currenciesDonation, t('language'))}</h3>
              <p className="sub-text">
                kg CO<sub>2</sub>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('language')(DonorHeaderComponent);
